<div class="wrapper">
  <app-public-header
    [register]="navService.getConfig()"
    [showNavbarLegacy]="showNavbarLegacy"
    [showNavbarNew]="showNavbarNew"></app-public-header>
  <div class="wrapper__content">
    <router-outlet></router-outlet>
  </div>
</div>
